import { render, staticRenderFns } from "./Productsblock.vue?vue&type=template&id=732e0f3f"
import script from "./Productsblock.vue?vue&type=script&lang=js"
export * from "./Productsblock.vue?vue&type=script&lang=js"
import style0 from "./Productsblock.vue?vue&type=style&index=0&id=732e0f3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports